
import {initializeApp} from "firebase/app";
import {getFirestore} from "firebase/firestore"
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyD5TOGM-eB1MJm8sojO2v_hHnfRumKIJSM",
    authDomain: "netflix-build-a9aad.firebaseapp.com",
    projectId: "netflix-build-a9aad",
    storageBucket: "netflix-build-a9aad.appspot.com",
    messagingSenderId: "1098549860341",
    appId: "1:1098549860341:web:165755ef723789978432bc"
  };

  const firebaseApp = initializeApp
  (firebaseConfig);
  const db = getFirestore(firebaseApp);
  const auth = getAuth(firebaseApp);


  export {auth, db}